import * as React from 'react'
import { hashHistory } from 'react-router'
import PropTypes from 'prop-types'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { Grid } from '@mui/material'
import AddOutlinedIcon from '@mui/icons-material/AddOutlined'
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined'
import ButtonInc from '../../../../../shared-ui/ButtonInc'
import { useStyle } from './Style'
import Audit from '../../../../../containers/Audits/index'

// components
import PolicyDetails from '../PolicyDetails/PolicyDetails'
import Quotes from '../PolicyDetails/Quotes'
import CoverLinkQuotesList from '../PolicyDetails/Components/Coverlink/CoverLinkQuotesList'
import PolicyQuotesList from '../PolicyDetails/PolicyQuotesList'
import { getPartnerGuid } from '../../../../../lib/access.es6'
import {
  PARTNERS_GUID_ENUM,
  PARTNERS_WITH_POLICY_QUOTATION_LIST
} from '../../../../../routes/PartnersEnum'
import { isOmkAgent } from '../../../../OldMutualKenya/shared/agentView'
import Documents from '../PolicyDetails/Documents'
import Notes from '../PolicyDetails/Notes'
import Dependants from '../PolicyDetails/Dependants'
import Payments from '../PolicyDetails/Payments'
import DebitOrders from '../PolicyDetails/Components/DebitOrders/DebitOrders'
import Premiums from '../PolicyDetails/Components/Premiums/Premiums'
import Claims from '../PolicyDetails/Components/Claims/Claims'
import RealPayContract from '../PolicyDetails/Components/RealPay/RealPayContract'
import PolicyRefunds from '../PolicyDetails/Components/Refunds/PolicyRefunds'
import GeneratePaymentLink from '../GeneratePaymentLink/GeneratePaymentLink'
import { canAccess } from '../../../../../lib/utils.es6'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {/* component="div": identical Typography styling but a valid
              block-level wrapper, so tab content (cards/Grids/paragraphs)
              doesn't nest inside a <p> (avoids validateDOMNesting warnings) */}
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`
  }
}

const NavigationWrapper = props => {
  const isCoverLink = getPartnerGuid() === PARTNERS_GUID_ENUM.COVER_LINK
  const isOmk = getPartnerGuid() === PARTNERS_GUID_ENUM.OLDMUTUAL_KENYA
  const isSamba = getPartnerGuid() === PARTNERS_GUID_ENUM.SAMBA
  // OMK does not collect premiums by debit order, so the tab and everything
  // it opens stay hidden for them. Each Tab carries an explicit value so the
  // remaining tabs keep pointing at their own panels.
  const showDebitOrders = !isOmk
  // OMK agents get a single tab. Everything else here is either operational
  // (payments, premiums, notes, audits) or another team's work (claims), and
  // none of it is scoped to the agent who sold the policy.
  const showAdminTabs = !isOmkAgent()

  // Runs once on mount only — props (including the new checkout-link state)
  // change on every re-render, and re-running these on each one would
  // refetch the customer/quotes on every keystroke elsewhere on the page.
  React.useEffect(() => {
    props.getCustomerDetails()
    // The Quotes tab is hidden for agents, so its fetch would be waste.
    if (props.getCustomerQuotes && showAdminTabs) {
      props.getCustomerQuotes()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Show all of this policy's quotations (an amendment creates a new one)
  // rather than the single attached quotation.
  const showPolicyQuotes =
    PARTNERS_WITH_POLICY_QUOTATION_LIST.indexOf(getPartnerGuid()) !== -1
  const policyGuid = props.policy && props.policy.guid
  const policyQuotes = Array.isArray(props.customerQuotes)
    ? props.customerQuotes.filter(function(quote) {
        return quote && quote.policy_guid === policyGuid
      })
    : []

  const classes = useStyle()
  const [value, setValue] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  const viewCustomerDetail = customer_guid => {
    if (customer_guid) {
      hashHistory.push(`admin/customer_status/${customer_guid}`)
    }
  }
  const makeAClaim = customer_guid => {
    hashHistory.push(`admin/claim-initiation-complex/${customer_guid}`)
  }

  return (
    <>
      <Box sx={{ flexGrow: 1, display: 'flex', height: 'auto' }}>
        <Tabs
          orientation="vertical"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          sx={{ borderRight: 1, borderColor: 'divider', width: '18%' }}
          className={classes.tabs}
        >
          <Tab label="Policy" value={0} {...a11yProps(0)} />
          {showAdminTabs && (
            <Tab label="Dependants" value={1} {...a11yProps(1)} />
          )}
          {showAdminTabs && (
            <Tab label="Documents" value={2} {...a11yProps(2)} />
          )}
          {showAdminTabs && (
            <Tab label="Payments" value={3} {...a11yProps(3)} />
          )}
          {showAdminTabs && (
            <Tab label="Premiums" value={4} {...a11yProps(4)} />
          )}
          {showAdminTabs && <Tab label="Quotes" value={5} {...a11yProps(5)} />}
          {showAdminTabs && showDebitOrders && (
            <Tab label="Debit Orders" value={6} {...a11yProps(6)} />
          )}
          {showAdminTabs && <Tab label="Notes" value={7} {...a11yProps(7)} />}
          {showAdminTabs && <Tab label="Claims" value={8} {...a11yProps(8)} />}
          {showAdminTabs && <Tab label="Audits" value={9} {...a11yProps(9)} />}
          {showAdminTabs && isCoverLink && (
            <Tab label="RealPay" value={10} {...a11yProps(10)} />
          )}
          {showAdminTabs && isSamba && (
            <Tab label="Refunds" value={11} {...a11yProps(11)} />
          )}
        </Tabs>
        <TabPanel value={value} index={0} className={classes.tabPanels}>
          <Grid container spacing={2} className={classes.tabheading}>
            <Grid item xs={12} sm={6} md={6}>
              <h1>Policy</h1>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{
                textAlign: 'end'
              }}
            >
              <ButtonInc
                onClick={() => viewCustomerDetail(props.policy.customer_guid)}
                style={{
                  border: '1px solid #FBA92D',
                  borderRadius: '8px',
                  background: '#fff',
                  padding: '5px 35px'
                }}
              >
                <span style={{ color: '#000000' }}>View Customer Details</span>
                <ChevronRightOutlinedIcon
                  sx={{
                    color: '#000000',
                    marginLeft: '10px'
                  }}
                />
              </ButtonInc>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <PolicyDetails
                policy={props.policy}
                setPolicyToDownloadDocumentFor={
                  props.setPolicyToDownloadDocumentFor
                }
                setPolicyToEmailDocumentFor={props.setPolicyToEmailDocumentFor}
                toggleOpenCancelPolicyDialog={
                  props.toggleOpenCancelPolicyDialog
                }
                toggleUpdateBeneficaryDialog={
                  props.toggleUpdateBeneficaryDialog
                }
                toggleUpgradeDialog={props.toggleUpgradeDialog}
                setQuotationToReCreate={props.setQuotationToReCreate}
                togglePolicyUpgradeDialog={props.togglePolicyUpgradeDialog}
                setPolicyToUpgrade={props.setPolicyToUpgrade}
                setPaymentInitiation={props.setPaymentInitiation}
                toggleTransferPolicyDialog={props.toggleTransferPolicyDialog}
              />
            </Grid>
          </Grid>
        </TabPanel>

        <TabPanel value={value} index={1} className={classes.tabPanels}>
          <Grid container spacing={2} className={classes.tabheading}>
            <Grid item xs={12} sm={6} md={6}>
              <h1>Dependants</h1>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{
                textAlign: 'end'
              }}
            ></Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <Dependants
                policy={props.policy}
                claims={props.claims}
                getClaims={props.getClaims}
              />
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={2} className={classes.tabPanels}>
          <Grid container spacing={2} className={classes.tabheading}>
            <Grid item xs={12} sm={6} md={6}>
              <h1>Documents</h1>
            </Grid>

            {canAccess(['UPLOAD_POLICY_DOCUMENT']) && (
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                style={{
                  textAlign: 'end'
                }}
              >
                <ButtonInc
                  onClick={props.toggleOpenPolicyDocumentDialog}
                  style={{
                    border: '1px solid #FBA92D',
                    borderRadius: '8px',
                    background: '#fff',
                    padding: '5px 35px'
                  }}
                >
                  <span style={{ color: '#000000' }}>Add Policy Document</span>
                  <AddOutlinedIcon
                    sx={{
                      color: '#000000',
                      marginLeft: '10px'
                    }}
                  />
                </ButtonInc>
              </Grid>
            )}
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <Documents
                documents={props.policy.policy_onboarding_documents}
                setDocumentToDelete={props.setDocumentToDelete}
                policyActiveState={props.policyActiveState}
              />
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={3} className={classes.tabPanels}>
          <Grid container spacing={2} className={classes.tabheading}>
            <Grid item xs={12}>
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 1
                }}
              >
                <h1>Payments</h1>
                <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: 1 }}>
                  <GeneratePaymentLink
                    policy={props.policy}
                    customer={props.customer}
                    generatePolicyCheckoutLink={
                      props.generatePolicyCheckoutLink
                    }
                    checkoutLinkLoader={props.checkoutLinkLoader}
                    checkoutLinkUrl={props.checkoutLinkUrl}
                    checkoutLinkError={props.checkoutLinkError}
                    resetPolicyCheckoutLink={props.resetPolicyCheckoutLink}
                  />
                  {canAccess(['PREMIUM_UPDATE']) && (
                    <ButtonInc
                      onClick={props.toggleAddPaymentDialog}
                      style={{
                        border: '1px solid #FBA92D',
                        borderRadius: '8px',
                        background: '#fff',
                        padding: '5px 35px'
                      }}
                    >
                      <span style={{ color: '#000000' }}>
                        Add Policy Payment
                      </span>
                      <AddOutlinedIcon
                        sx={{
                          color: '#000000',
                          marginLeft: '10px'
                        }}
                      />
                    </ButtonInc>
                  )}
                </Box>
              </Box>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <Payments
                policy={props.policy}
                getAllPayments={props.getAllPayments}
                payments={props.payments}
                loader={props.loader}
              />
            </Grid>
          </Grid>
        </TabPanel>

        <TabPanel value={value} index={4} className={classes.tabPanels}>
          <Grid container spacing={2} className={classes.tabheading}>
            <Grid item xs={12} sm={6} md={6}>
              <h1>Premiums</h1>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{
                textAlign: 'end'
              }}
            ></Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <Premiums
                getPremiums={props.getPremiums}
                premiums={props.premiums}
                premiumsloader={props.premiumsloader}
                policyGuid={props.policyGuid}
                setPremiumToRemove={props.setPremiumToRemove}
              />
            </Grid>
          </Grid>
        </TabPanel>

        <TabPanel value={value} index={5} className={classes.tabPanels}>
          <Grid container spacing={2} className={classes.tabheading}>
            <Grid item xs={12} sm={6} md={6}>
              <h1>Quotes</h1>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{
                textAlign: 'end'
              }}
            ></Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              {showPolicyQuotes ? (
                <PolicyQuotesList
                  quotes={policyQuotes}
                  loader={props.customerQuotesLoader}
                  error={props.customerQuotesError}
                  onDecision={isOmk ? props.quotationDecision : undefined}
                  decisionLoader={props.quotationDecisionLoader}
                  decisionSuccess={props.quotationDecisionSuccess}
                  decisionError={props.quotationDecisionError}
                />
              ) : isCoverLink ? (
                <CoverLinkQuotesList
                  quotes={props.customerQuotes}
                  loader={props.customerQuotesLoader}
                  error={props.customerQuotesError}
                />
              ) : (
                <Quotes
                  quotes={props.policy.quotation}
                  policy={props.policy}
                  setQuoteToDownloadDocumentFor={
                    props.setQuoteToDownloadDocumentFor
                  }
                />
              )}
            </Grid>
          </Grid>
        </TabPanel>

        {showDebitOrders && (
          <TabPanel value={value} index={6} className={classes.tabPanels}>
            <Grid container spacing={2} className={classes.tabheading}>
              <Grid item xs={12} sm={6} md={6}>
                <h1>Debit Orders</h1>
              </Grid>
              {canAccess(['CREATE_DEBIT_ORDER']) && (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  style={{
                    textAlign: 'end'
                  }}
                >
                  <ButtonInc
                    onClick={props.toggleAddDebitOrderDialog}
                    style={{
                      border: '1px solid #FBA92D',
                      borderRadius: '8px',
                      background: '#fff',
                      padding: '5px 35px',
                      display: canAccess(['CAPTURE_POLICY'])
                        ? 'inline-flex'
                        : 'none'
                    }}
                  >
                    <span style={{ color: '#000000' }}>Add Debit Order</span>
                    <AddOutlinedIcon
                      sx={{
                        color: '#000000',
                        marginLeft: '10px'
                      }}
                    />
                  </ButtonInc>
                </Grid>
              )}
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12}>
                <DebitOrders
                  getAllDebitOrders={props.getAllDebitOrders}
                  newDebitOrderData={props.newDebitOrderData}
                  customer={props.customer}
                  debitOrderloader={props.debitOrderloader}
                  policyGuid={props.policyGuid}
                  setDebitOrderToDelete={props.setDebitOrderToDelete}
                  setDebitOrderToEdit={props.setDebitOrderToEdit}
                  debitOrderToEdit={props.debitOrderToEdit}
                  toggleEditDebitOrderDialog={props.toggleEditDebitOrderDialog}
                />
              </Grid>
            </Grid>
          </TabPanel>
        )}

        <TabPanel value={value} index={7} className={classes.tabPanels}>
          <Grid container spacing={2} className={classes.tabheading}>
            <Grid item xs={12} sm={6} md={6}>
              <h1>Notes</h1>
            </Grid>

            {canAccess(['ADD_POLICY_NOTES']) && (
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                style={{
                  textAlign: 'end'
                }}
              >
                <ButtonInc
                  onClick={props.toggleOpenPolicyNoteDialog}
                  style={{
                    border: '1px solid #FBA92D',
                    borderRadius: '8px',
                    background: '#fff',
                    padding: '5px 35px',
                    display: canAccess(['CAPTURE_POLICY'])
                      ? 'inline-flex'
                      : 'none'
                  }}
                >
                  <span style={{ color: '#000000' }}>Add Policy Note</span>
                  <AddOutlinedIcon
                    sx={{
                      color: '#000000',
                      marginLeft: '10px'
                    }}
                  />
                </ButtonInc>
              </Grid>
            )}
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <Notes notes={props.policy.notes} />
            </Grid>
          </Grid>
        </TabPanel>

        <TabPanel value={value} index={8} className={classes.tabPanels}>
          <Grid container spacing={2} className={classes.tabheading}>
            <Grid item xs={12} sm={6} md={6}>
              <h1>Claims</h1>
            </Grid>

            {canAccess(['CREATE_CLAIM']) && (
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                style={{
                  textAlign: 'end'
                }}
              >
                <ButtonInc
                  onClick={() => makeAClaim(props.customer_guid)}
                  style={{
                    border: '1px solid #FBA92D',
                    borderRadius: '8px',
                    background: '#fff',
                    padding: '5px 35px'
                  }}
                >
                  <span style={{ color: '#000000' }}>Make A Claim</span>
                  <ChevronRightOutlinedIcon
                    sx={{
                      color: '#000000',
                      marginLeft: '10px'
                    }}
                  />
                </ButtonInc>
              </Grid>
            )}
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <Claims
                policyGuid={props.policyGuid}
                getClaims={props.getClaims}
                claims={props.claims}
                claimsloader={props.claimsloader}
                getCustomerPolicies={props.getCustomerPolicies}
              />
            </Grid>
          </Grid>
        </TabPanel>

        <TabPanel value={value} index={9} className={classes.tabPanels}>
          <Grid container spacing={2} className={classes.tabheading}>
            <Grid item xs={12} sm={6} md={6}>
              <h1> Audits</h1>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{
                textAlign: 'end'
              }}
            ></Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <Audit entity_guid={props.policyGuid} />
            </Grid>
          </Grid>
        </TabPanel>

        {isCoverLink && (
          <TabPanel value={value} index={10} className={classes.tabPanels}>
            <Grid container spacing={2} className={classes.tabheading}>
              <Grid item xs={12} sm={6} md={6}>
                <h1>RealPay</h1>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12}>
                <RealPayContract policy={props.policy} />
              </Grid>
            </Grid>
          </TabPanel>
        )}

        {isSamba && (
          <TabPanel value={value} index={11} className={classes.tabPanels}>
            <Grid container spacing={2} className={classes.tabheading}>
              <Grid item xs={12} sm={6} md={6}>
                <h1>Refunds</h1>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12}>
                <PolicyRefunds policy={props.policy} />
              </Grid>
            </Grid>
          </TabPanel>
        )}
      </Box>
    </>
  )
}

export default NavigationWrapper
